import { render } from "./letter-create-import.vue?vue&type=template&id=0d23ff99"
import script from "./letter-create-import.vue?vue&type=script&lang=js"
export * from "./letter-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__